import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import {
	TDef,
	Container,
	WrapperCell,
	StudentNameCell,
	StudentAttendanceCell,
	StudentIdCell,
	StudentStateCell,
	StudentInscriptionDateCell,
} from "./styles";
import { getDatePartsByMillis } from "components/CustomDatePicker/utils/helpers";

const ListItem = ({
	index,
	dataOfList,
	id,
	name,
	inscriptionDate,
	disabled,
	attendance,
	changeAttendance,
	errorSaveAttendance,
	isPinned,
}) => {
	const getDateInFormat = dateLong => {
		const dateInscriptionParts = getDatePartsByMillis(dateLong);
		return `${dateInscriptionParts[2]}/${dateInscriptionParts[1]+1}/${dateInscriptionParts[0]}`;
	}
	const getPositionRow = () => {
		const { index, length } = dataOfList;
		return index === 0 ? 1 : index === length - 1 ? -1 : 0;
	};
	const isOnlyOne = () => {
		return dataOfList.length === 1;
	};
	const getClassName = (positionCell = 1) => {
		const classList = [];
		const positionRow = getPositionRow();
		if (positionRow !== 0)
			classList.push(positionRow === 1 ? "first-row" : "last-row");
		if (positionCell !== 0)
			classList.push(positionCell === 1 ? "first-cell" : "last-cell");
		isPinned && classList.push("is-pinned");
		isOnlyOne() && classList.push("only-one");
		return classList.join(" ");
	};
	const studentIdClassName = getClassName(1),
		studentNameClassName = getClassName(0),
		studentAttendanceClassName = getClassName(-1);
	return (
		<Container>
			<TDef>
				<StudentIdCell className={studentIdClassName}>
					<WrapperCell className={studentIdClassName}>
						<span>{id}</span>
					</WrapperCell>
				</StudentIdCell>
			</TDef>
			<TDef>
				<StudentNameCell className={studentNameClassName}>
					<WrapperCell className={studentNameClassName}>
						<span>{name}</span>
					</WrapperCell>
				</StudentNameCell>
			</TDef>
			<TDef>
				<StudentStateCell className={studentNameClassName}>
					<WrapperCell className={studentNameClassName}>
						<span>Inscrito</span>
					</WrapperCell>
				</StudentStateCell>
			</TDef>
			<TDef>
				<StudentInscriptionDateCell className={studentNameClassName}>
					<WrapperCell className={studentNameClassName}>
						<span>{getDateInFormat(inscriptionDate)}</span>
					</WrapperCell>
				</StudentInscriptionDateCell>
			</TDef>
			<TDef>
				<StudentAttendanceCell className={studentAttendanceClassName}>
					<WrapperCell className={studentAttendanceClassName}>
						<CustomCheckbox
							disabled={disabled}
							onChange={() => changeAttendance(id)}
							checked={attendance}
							error={errorSaveAttendance}
						/>
					</WrapperCell>
				</StudentAttendanceCell>
			</TDef>
		</Container>
	);
};

export default ListItem;
